module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"apps-menu":{"your-apps":"Seus apps","dash":"Dash","pix":"Pix","get-to-know":"Conheça"},"logout":"Sair","company":"Company","profile":"Perfil","backoffice":"Backoffice"},"en-US":{"apps-menu":{"your-apps":"Your apps","dash":"Dash","pix":"Pix","get-to-know":"Get to know"},"logout":"Logout","company":"Company","profile":"Profile","backoffice":"Backoffice"}}')
  delete Component.options._Ctor
}
